import {Component, Input} from '@angular/core';
import {KnobModule} from "primeng/knob";
import {FormsModule} from "@angular/forms";
import {NgClass} from "@angular/common";
import {TooltipModule} from "primeng/tooltip";

@Component({
  selector: 'app-knop',
  standalone: true,
    imports: [
        KnobModule,
        FormsModule,
        NgClass,
        TooltipModule
    ],
  templateUrl: './knop.component.html',
  styleUrl: './knop.component.scss'
})
export class KnopComponent {
    @Input() value: number | any | undefined
    @Input() label: string = '';
    @Input() customClass: string = '';
    @Input() size: number = 0;
    @Input() strokeWidth:number = 10;


    valueColor(value: number): string {
        if (value === 100) {
            return '#008000FF';  //verde 100%
        }
        if (value >= 70) {
            return '#2196F3';  //valores entre 70% y 99%
        }
        if (value >= 30) {
            return '#FFA500';  //valores entre 30% y 69%
        }
        return '#d30e0e';  //valores por debajo de 30%
    }

}
